import React from 'react';
import { defaultTheme } from '@nxsys/constants/defaultConfig';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
  disabledColor?: string;
};

const IconExport: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = defaultTheme.theme.palette.neutral[700],
  disabled = false,
  disabledColor = defaultTheme.theme.palette.neutral[400],
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1084 7.05833L12.1084 2.05833C11.9909 1.94083 11.8326 1.875 11.6667 1.875H6.66675C4.65175 1.875 3.54175 2.985 3.54175 5V15C3.54175 17.015 4.65175 18.125 6.66675 18.125H14.1667C16.1817 18.125 17.2917 17.015 17.2917 15V7.5C17.2917 7.33417 17.2259 7.175 17.1084 7.05833ZM12.2917 4.00917L15.1576 6.875H14.1667C12.8526 6.875 12.2917 6.31417 12.2917 5V4.00917ZM14.1667 16.875H6.66675C5.35258 16.875 4.79175 16.3142 4.79175 15V5C4.79175 3.68583 5.35258 3.125 6.66675 3.125H11.0417V5C11.0417 7.015 12.1517 8.125 14.1667 8.125H16.0417V15C16.0417 16.3142 15.4809 16.875 14.1667 16.875ZM12.2433 12.7392C12.2117 12.8158 12.1659 12.885 12.1084 12.9425L10.4418 14.6092C10.3201 14.7308 10.1601 14.7925 10.0001 14.7925C9.84008 14.7925 9.68006 14.7317 9.55839 14.6092C9.31422 14.365 9.31422 13.9692 9.55839 13.725L10.1584 13.125H7.50008C7.15508 13.125 6.87508 12.845 6.87508 12.5C6.87508 12.155 7.15508 11.875 7.50008 11.875H10.1576L9.55758 11.275C9.31341 11.0308 9.31341 10.635 9.55758 10.3908C9.80174 10.1467 10.1976 10.1467 10.4418 10.3908L12.1084 12.0575C12.1659 12.115 12.2117 12.1842 12.2433 12.2608C12.3067 12.4133 12.3067 12.5867 12.2433 12.7392Z"
      fill={disabled ? disabledColor : color}
    />
  </svg>
);

export default IconExport;
